import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ReferentiesPage from "@/pages/ReferentiesPage";
import ContactPage from "@/pages/ContactPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";

function App() {
  return (
    <div className="App min-h-screen bg-mist font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/over-rabia" element={<AboutPage />} />
            <Route path="/diensten" element={<ServicesPage />} />
            <Route path="/referenties" element={<ReferentiesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/privacyverklaring" element={<PrivacyPage />} />
            <Route path="/cookiebeleid" element={<CookiePolicyPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
